import { render, staticRenderFns } from "./limit-batch-approval-detail.vue?vue&type=template&id=1cd2a979&scoped=true"
import script from "./limit-batch-approval-detail.vue?vue&type=script&lang=js"
export * from "./limit-batch-approval-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2a979",
  null
  
)

export default component.exports